import React, { FC, useEffect, useState } from "react";
import {
  QuestionConfigDetailDto,
  QuestionConfigTranslationDto,
} from "@green0meter/api-client";

import { StyledTextField } from "../../QuestionTypeEditor.styled";

import { useQuestionEditorStore } from "@components/main/questions/QuestionEditor";

interface TextInput {
  questionConfig: QuestionConfigDetailDto;
  setQuestionConfig: (questionConfig: QuestionConfigDetailDto) => void;
}

const TextInput: FC<TextInput> = ({ questionConfig, setQuestionConfig }) => {
  const { language } = useQuestionEditorStore();
  const [translation, setTranslation] = useState<QuestionConfigTranslationDto>();

  const handleChangePlaceholder = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    if (questionConfig) {
      setQuestionConfig({
        ...questionConfig,
        translations: questionConfig.translations.map((translation) =>
          translation.language === language
            ? { ...translation, placeholder: event.target.value }
            : translation,
        ),
      });
    }
  };

  useEffect(() => {
    if (questionConfig) {
      const currentTranslation = questionConfig.translations.find(
        (translation) => translation.language === language,
      );

      setTranslation(currentTranslation);
    }
  }, [questionConfig, language]);

  return (
    <StyledTextField
      value={translation?.placeholder || ""}
      variant="filled"
      onChange={handleChangePlaceholder}
      placeholder="Placeholder text"
      fullWidth
    />
  );
};

export default TextInput;
